import { CSSObject } from '@emotion/css';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

export const baseInputStyle: CSSObject = {
  border: '1px solid var(--color-muted)',
  color: 'var(--color-body)',
  fontFamily: 'var(--font-body)',
  fontSize: pxToRem(16),
  fontWeight: 'var(--font-weight-regular)' as any,
  lineHeight: pxToRem(24),
  padding: `${pxToRem(8)} ${pxToRem(12)}`,
  width: '100%',
  height: pxToRem(48),

  [mqBreakpoints.tablet]: {
    padding: `${pxToRem(12)} ${pxToRem(16)}`,
    width: pxToRem(240),
  },

  '&:hover': {
    border: '1px solid var(--color-body)',
  },

  '&:active': {
    border: '1px solid var(--color-body)',
    //boxShadow: '0 0 0 1px var(--color-body)',
  },

  '&:focus': {
    border: '1px solid var(--color-body)',
    //boxShadow: '0 0 0 1px var(--color-body)',
    //outline: 'none',
  },

  '&:disabled': {
    backgroundColor: 'var(--color-light)',
    border: '1px solid var(--color-muted)',
  },
};

export const hideBrowserCheckboxAndRadio: CSSObject = {
  position: 'absolute',
  width: 0,
  height: 0,
  opacity: 0,
};
